import { render, staticRenderFns } from "./shequhuodong1.vue?vue&type=template&id=44816e6a&scoped=true&"
import script from "./shequhuodong1.vue?vue&type=script&lang=js&"
export * from "./shequhuodong1.vue?vue&type=script&lang=js&"
import style0 from "./shequhuodong1.vue?vue&type=style&index=0&id=44816e6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44816e6a",
  null
  
)

export default component.exports